<ngx-spinner  bdColor="rgba(128, 128, 128, 0.8)"
              size="default"
              color="#2f9cf2"
              type="line-scale-pulse-out"
              [name]="spinnerName"
              [fullScreen]="false"><p style="color:white">{{spinnerText}}</p></ngx-spinner>
<p-toast position="top-right"></p-toast>

<div class="roster-setting" style="height:100%;">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
      <span style="padding-top:2px;">
        <button (click)="loadRosterSettings()"
                pButton type="button" 
                title="Refresh all roster settings"
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh"></button>
      </span>      
    </div>
  </p-toolbar>

  <p-tabView (onChange)="tabSwitched($event)" [activeIndex]="activeTabIndex">
    <p-tabPanel *ngIf="canManageRosterProject()" header="Roster Project" leftIcon="fas fa-align-justify" tooltip="Manage roster project">
      <pps-manage-roster-project 
        *ngIf="dataIsReady"
        [maxNumberOfRosterProject]="rosterSettings.maxNumberOfRosterProject"
        [rosterProjects]="rosterSettings.rosterProjects"
        [roles]="rosterSettings.roles"
        [workGroups]="rosterSettings.workGroups"></pps-manage-roster-project>

    </p-tabPanel>

    <p-tabPanel header="Roster Type" leftIcon="pi-fw fas fa-braille" tooltip="Manage roster type">
      <pps-manage-roster-type
        *ngIf="dataIsReady"
        [rosterTypes]="rosterSettings.rosterTypes"
        [rosterCodes]="rosterSettings.rosterCodes"
        [rosterCodeSettings]="rosterSettings.rosterCodeSettings" ></pps-manage-roster-type>
    </p-tabPanel>

    <p-tabPanel header="Roster Type by Work Group & Position" leftIcon="fas fa-sliders-h" tooltip="Manage work group, position and roster type">
      <pps-manage-workgroup-position-rostertype
        *ngIf="dataIsReady"
        [data]="rosterSettings.workGroupPositionRosterTypes"
        [rosterTypes]="rosterSettings.rosterTypes"
        [positions]="rosterSettings.positions"
        [workGroups]="rosterSettings.workGroups"></pps-manage-workgroup-position-rostertype>
    </p-tabPanel>

    <p-tabPanel header="Roster Code Settings" leftIcon="fas fa-palette" tooltip="Manage roster code color settings, ticket status etc.">
      <pps-manage-roster-code-settings
        *ngIf="dataIsReady"
        [rosterCodeSettings]="rosterSettings.rosterCodeSettings"></pps-manage-roster-code-settings>
    </p-tabPanel>

    <p-tabPanel class="work-area" header="Work Area" leftIcon="fas fa-warehouse" tooltip="Manage work area.">
      <pps-manage-work-area
        *ngIf="dataIsReady"
        [workAreas]="rosterSettings.workAreas"
        [employees]="rosterSettings.employees"></pps-manage-work-area>
    </p-tabPanel>
    
    <p-tabPanel header="Roster Summary" leftIcon="fas fa-align-justify" tooltip="Manage roster summary lines.">
      <pps-manage-roster-summary-line
        *ngIf="dataIsReady"
        [rosterCodes]="rosterSettings.rosterCodes"
        [workGroups]="rosterSettings.workGroups"
        [employers]="rosterSettings.employers"
        [rosterSummaryLines]="rosterSettings.rosterSummaryLines"
        [rosterProjects]="rosterSettings.rosterProjects"
        ></pps-manage-roster-summary-line>
    </p-tabPanel>

  </p-tabView>
</div>